'use client'

import { env } from '@mc/runtime-env'

const DEFAULT_SERVICE_NAME = 'frontend-browser'

export type OtelEnv = {
  serviceName: string | undefined
  endpoint: string | undefined
  tracesEndpoint: string | undefined
  headers: string | undefined
  tracesHeaders: string | undefined
  timeout: string | undefined
  tracesTimeout: string | undefined
  cxApplicationName: string | undefined
  cxSubsystemName: string | undefined
}

let _OTEL_CONFIG: OtelEnv | null = null

export const getOtelConfig = (): OtelEnv => {
  if (!_OTEL_CONFIG) {
    _OTEL_CONFIG = {
      serviceName: env('NEXT_PUBLIC_OTEL_SERVICE_NAME'),
      endpoint: env('NEXT_PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT'),
      tracesEndpoint: env('NEXT_PUBLIC_OTEL_EXPORTER_OTLP_TRACES_ENDPOINT'),
      headers: env('NEXT_PUBLIC_OTEL_EXPORTER_OTLP_HEADERS'),
      tracesHeaders: env('NEXT_PUBLIC_OTEL_EXPORTER_OTLP_TRACES_HEADERS'),
      timeout: env('NEXT_PUBLIC_OTEL_EXPORTER_OTLP_TIMEOUT'),
      tracesTimeout: env('NEXT_PUBLIC_OTEL_EXPORTER_OTLP_TRACES_TIMEOUT'),
      cxApplicationName: env('NEXT_PUBLIC_OTEL_CX_APPLICATION_NAME'),
      cxSubsystemName: env('NEXT_PUBLIC_OTEL_CX_SUBSYSTEM_NAME'),
    }
  }
  return _OTEL_CONFIG
}

export const parseHeaders = (hs?: string): Record<string, string> | undefined =>
  hs?.split(',').reduce<Record<string, string>>((headers, pair) => {
    const [k, v] = pair.split('=')
    if (v !== undefined) headers[k] = v
    return headers
  }, {})

export const getWebServiceName = () =>
  getOtelConfig().serviceName ?? DEFAULT_SERVICE_NAME

let initialized = false

// Dynamic import keeps zone.js (loaded by @opentelemetry/context-zone in
// initTracingClient) out of any module-eval chain reachable from
// TracingService — without it, jsdom-based tests
// fail because zone.js patches global addEventListener.
export const initTracing = () => {
  if (typeof window === 'undefined') return
  if (initialized) return
  const OTEL_CONFIG = getOtelConfig()
  if (!OTEL_CONFIG.endpoint && !OTEL_CONFIG.tracesEndpoint) {
    // eslint-disable-next-line no-console
    console.log('instrumentation not configured, not registering')
    return
  }
  initialized = true
  import('./initTracingClient').then((m) => m.initTracingClient())
}
